<template>
  <div :class="isWidget ? 'tool-widget' : 'tool-page'">
    <div class="tool-content">
      <div v-if="!isWidget" class="tool-heading">
        <div>
          <h2>提取视频</h2>
          <p>粘贴短视频分享链接，提取文案、无水印视频和图片</p>
        </div>
        <app-icon  class="app-icon" name="download"></app-icon>
      </div>

      <div class="tool-card">
        <section class="section-block">
          <div class="section-title">视频链接</div>
          <el-input v-model="qsyurl" type="textarea" :rows="3"
            placeholder="请在此处粘贴视频或图片链接，支持live实况图，画质无损（永久免费）" clearable>
          </el-input>
          <div class="input-actions">
            <span class="action-item" @click="paste">
              <app-icon  class="app-icon" name="content_paste"></app-icon>
              粘贴内容
            </span>
            <span class="action-divider"></span>
            <span class="action-item" @click="qsyurl = ''">
              <app-icon  class="app-icon" name="close"></app-icon>
              清空
            </span>
          </div>
        </section>

        <el-button class="submit-btn" type="primary" :loading="loading" @click="start">
          立即提取
        </el-button>
      </div>

      <template v-if="hasResult">
        <section v-if="result.desc" class="result-panel">
          <div class="panel-title">
            <app-icon  class="app-icon" name="notes"></app-icon>
            文案
            <span class="panel-sub">点击内容可复制</span>
          </div>
          <div class="desc-box" @click="copy(result.desc)">{{ result.desc }}</div>
          <div class="panel-actions">
            <el-button size="small" type="primary" plain @click="copy(result.desc)">复制文案</el-button>
          </div>
        </section>

        <section v-if="result.video" class="result-panel">
          <div class="panel-title">
            <app-icon  class="app-icon" name="movie"></app-icon>
            视频
          </div>
          <video :src="result.video" controls class="video-player"></video>
          <div class="panel-actions">
            <el-button size="small" type="primary" @click="downloadVideo">下载视频</el-button>
            <el-button size="small" @click="copy(result.video)">复制视频链接</el-button>
          </div>
        </section>

        <section v-if="result.pics.length" class="result-panel">
          <div class="panel-title">
            <app-icon  class="app-icon" name="photo_library"></app-icon>
            图片
            <span class="panel-sub">共 {{ result.pics.length }} 张，点击可预览</span>
          </div>
          <div class="pics-grid">
            <div v-for="(pic, index) in result.pics" :key="index" class="pic-item">
              <el-image :src="pic" fit="cover" class="pic-image" :preview-src-list="result.pics"
                :initial-index="index">
                <div slot="error" class="image-error">
                  <app-icon  class="app-icon" name="broken_image"></app-icon>
                </div>
              </el-image>
              <div class="pic-actions">
                <span @click="copy(pic)">复制链接</span>
                <span @click="downloadImage(pic, index)">下载</span>
              </div>
            </div>
          </div>
          <div v-if="result.pics.length > 1" class="panel-actions">
            <el-button size="small" type="primary" plain :loading="downloadingAll" @click="downloadAllPics">
              全部下载
            </el-button>
          </div>
        </section>
      </template>
    </div>

    <el-dialog :visible.sync="showTipDialog" width="480px" :close-on-click-modal="false"
      custom-class="qsy2-dialog" @close="handleReject">
      <div slot="title" class="tip-header">
        <app-icon  class="tip-header-icon app-icon" name="verified_user"></app-icon>
        <div>
          <div class="tip-title">使用说明</div>
          <div class="tip-subtitle">请在使用前阅读以下内容</div>
        </div>
      </div>
      <div class="tip-content">
        <div class="tip-free">
          <app-icon  class="app-icon" name="redeem"></app-icon>
          <div>
            <strong>此功能免费提供</strong>
            <span>请遵守以下使用说明</span>
          </div>
        </div>
        <div class="tip-item tip-neutral">
          <app-icon  class="tip-item-icon app-icon" name="info"></app-icon>
          <div>
            <strong>功能用途</strong>
            <p>
              平台作为提供技术的中立工具，此功能仅限帮助用户提取视频自行学习、观看，降低视频、图片浏览障碍
            </p>
          </div>
        </div>
        <div class="tip-item tip-warning">
          <app-icon  class="tip-item-icon app-icon" name="gavel"></app-icon>
          <div>
            <strong>合法使用提示</strong>
            <p>
              用户请合法使用，若用户滥用该功能实施侵权行为，用户应自行承担由此产生的法律责任。平台倡导与用户共创营造良好网络环境！
            </p>
          </div>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="handleReject">拒绝</el-button>
        <el-button type="primary" @click="handleAgree">我知道了</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'User2Qsy',
  props: {
    limit: { type: Number, default: 0 }
  },
  data() {
    return {
      qsyurl: '',
      result: { desc: '', video: '', pics: [] },
      loading: false,
      downloadingAll: false,
      tishi: false,
      showTipDialog: false
    }
  },
  computed: {
    isWidget() { return this.limit > 0 },
    hasResult() {
      return !!(this.result.desc || this.result.video || this.result.pics.length)
    }
  },
  methods: {
    async paste() {
      try {
        const text = await navigator.clipboard.readText()
        this.qsyurl = text
        this.$message.success('粘贴成功')
      } catch (err) {
        this.$message.error('粘贴失败，请手动输入')
      }
    },
    start() {
      if (!this.qsyurl.trim()) {
        this.$message.warning('请输入链接')
        return
      }
      if (this.tishi !== 'agree') {
        this.showTipDialog = true
        return
      }
      this.qsy()
    },
    handleAgree() {
      this.tishi = 'agree'
      this.showTipDialog = false
      this.qsy()
    },
    handleReject() {
      this.tishi = false
      this.showTipDialog = false
    },
    qsy() {
      this.loading = true
      this.$ajax.post('qhy/user/qsyjk', { url: this.qsyurl }, {
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
      }).then(res => {
        const d = (res.data && res.data.data) || {}
        const pics = [].concat(d.pics || d.images || [], d.live_photos || []).filter(Boolean)
        this.result = {
          desc: d.desc || d.title || '',
          video: d.playAddr || d.video_url || '',
          pics
        }
        if (!this.hasResult) {
          this.$message.warning('未提取到可用的视频、图片或文案')
        }
      }).catch(err => {
        console.error('提取失败:', err)
        this.$message.error('提取失败，请稍后重试')
      }).finally(() => {
        this.loading = false
      })
    },
    copy(context) {
      if (!context) {
        this.$message.warning('没有可复制的内容')
        return
      }
      const done = () => this.$message.success('复制成功')
      const fallback = () => {
        try {
          const oInput = document.createElement('textarea')
          oInput.value = context
          oInput.style.position = 'fixed'
          oInput.style.opacity = '0'
          document.body.appendChild(oInput)
          oInput.select()
          document.execCommand('Copy')
          done()
          oInput.remove()
        } catch (e) {
          this.$message.error('复制失败')
        }
      }
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(context).then(done).catch(fallback)
      } else {
        fallback()
      }
    },
    async downloadImage(url, index, silent = false) {
      if (!url) return false
      try {
        const response = await fetch(url, { method: 'GET', mode: 'cors' })
        if (!response.ok) throw new Error('下载失败')
        const blob = await response.blob()
        const blobUrl = window.URL.createObjectURL(blob)
        const link = document.createElement('a')
        link.href = blobUrl
        link.download = `图片${index + 1}.jpg`
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
        window.URL.revokeObjectURL(blobUrl)
        if (!silent) this.$message.success('下载成功')
        return true
      } catch (error) {
        try {
          const link = document.createElement('a')
          link.href = url
          link.download = `图片${index + 1}.jpg`
          link.target = '_blank'
          document.body.appendChild(link)
          link.click()
          document.body.removeChild(link)
          if (!silent) {
            setTimeout(() => {
              this.$message({ message: '如果下载失败，请长按图片选择"保存图片"', type: 'warning', duration: 5000, showClose: true })
            }, 500)
          }
          return true
        } catch (e) {
          if (!silent) {
            this.$message({ message: '自动下载失败，请长按图片选择"保存图片"', type: 'warning', duration: 6000, showClose: true })
          }
          return false
        }
      }
    },
    downloadVideo() {
      if (!this.result.video) {
        this.$message.warning('视频链接不存在')
        return
      }
      const link = document.createElement('a')
      link.href = this.result.video
      link.download = 'video.mp4'
      link.target = '_blank'
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
      this.$message.success('开始下载')
    },
    async downloadAllPics() {
      this.downloadingAll = true
      let successCount = 0
      let failCount = 0
      for (let i = 0; i < this.result.pics.length; i++) {
        const ok = await this.downloadImage(this.result.pics[i], i, true)
        if (ok) successCount++
        else failCount++
        if (i < this.result.pics.length - 1) {
          await new Promise(resolve => setTimeout(resolve, 300))
        }
      }
      this.downloadingAll = false
      if (failCount > 0) {
        this.$message({
          message: `下载完成：成功 ${successCount} 张，失败 ${failCount} 张。失败的图片请长按选择"保存图片"`,
          type: failCount === this.result.pics.length ? 'warning' : 'info',
          duration: 6000,
          showClose: true
        })
      } else {
        this.$message.success(`成功下载 ${successCount} 张图片`)
      }
    }
  }
}
</script>

<style scoped>
.tool-page { min-height: 100%; padding: 24px 24px 48px; background: #f5f7fa; box-sizing: border-box; }
.tool-widget { box-sizing: border-box; }
.tool-widget .tool-card { padding: 0 0 24px; border: 0; box-shadow: none; }
.tool-widget .section-block:first-child .section-title { display: none; }
.tool-content { max-width: 1080px; margin: 0 auto; }
.tool-page .tool-content { padding-bottom: 48px; }
.tool-heading { display: flex; align-items: center; justify-content: space-between; margin-bottom: 18px; }
.tool-heading h2 { margin: 0 0 6px; color: #1e293b; font-size: 22px; }
.tool-heading p { margin: 0; color: #94a3b8; font-size: 13px; }
.tool-heading > span { padding: 11px; border-radius: 12px; background: #e8f1fe; color: #1a73e8; font-size: 28px; }
.tool-card { padding: 24px 24px 48px; border: 1px solid #e2e8f0; border-radius: 12px; background: #fff; box-shadow: 0 4px 16px rgba(15,23,42,.04); }
.section-title { margin-bottom: 12px; color: #1e293b; font-size: 14px; font-weight: 600; }
.input-actions { display: flex; align-items: center; gap: 14px; margin-top: 14px; color: #64748b; font-size: 13px; }
.action-item { display: inline-flex; align-items: center; gap: 4px; cursor: pointer; transition: color .2s; }
.action-item:hover { color: #1a73e8; }
.action-item .app-icon { font-size: 16px; }
.action-divider { width: 1px; height: 14px; background: #e2e8f0; }
.submit-btn { width: 100%; margin-top: 26px; border-color: #1a73e8; background: #1a73e8; }

.result-panel { margin-top: 18px; padding: 20px; border: 1px solid #e2e8f0; border-radius: 12px; background: #fff; box-shadow: 0 4px 16px rgba(15,23,42,.04); }
.panel-title { display: flex; align-items: center; gap: 7px; margin-bottom: 14px; color: #1e293b; font-size: 15px; font-weight: 600; }
.panel-title .app-icon { font-size: 19px; color: #1a73e8; }
.panel-sub { margin-left: 2px; color: #94a3b8; font-size: 12px; font-weight: 400; }
.desc-box { padding: 14px; border-radius: 8px; background: #f8fafc; color: #475569; font-size: 13px; line-height: 1.7; word-break: break-all; white-space: pre-wrap; cursor: pointer; }
.video-player { display: block; width: 100%; max-height: 420px; border-radius: 10px; background: #000; }
.panel-actions { display: flex; flex-wrap: wrap; gap: 10px; margin-top: 14px; }
.pics-grid { display: grid; grid-template-columns: repeat(4, 1fr); gap: 10px; }
.pic-item { position: relative; border-radius: 10px; overflow: hidden; background: #f5f5f5; }
.pic-image { display: block; width: 100%; height: 150px; }
.image-error { width: 100%; height: 100%; display: flex; align-items: center; justify-content: center; color: #c0c4cc; font-size: 26px; }
.pic-actions { display: flex; justify-content: space-between; padding: 7px 9px; font-size: 12px; color: #64748b; }
.pic-actions span { cursor: pointer; }
.pic-actions span:hover { color: #1a73e8; }
.tip-header { display: flex; align-items: center; gap: 12px; }
.tip-header-icon { display: flex; align-items: center; justify-content: center; width: 42px; height: 42px; border-radius: 12px; background: #e8f1fe; color: #1a73e8; font-size: 24px; }
.tip-title { color: #1e293b; font-size: 18px; font-weight: 700; line-height: 1.4; }
.tip-subtitle { margin-top: 2px; color: #94a3b8; font-size: 12px; line-height: 1.4; }
.tip-content { color: #475569; font-size: 14px; line-height: 1.7; }
.tip-free { display: flex; align-items: center; gap: 12px; margin-bottom: 14px; padding: 13px 15px; border: 1px solid #bfdbfe; border-radius: 10px; background: #eff6ff; color: #1d4ed8; }
.tip-free > span { font-size: 23px; }
.tip-free div { display: flex; flex-direction: column; line-height: 1.45; }
.tip-free strong { font-size: 14px; }
.tip-free div span { margin-top: 1px; color: #60a5fa; font-size: 12px; }
.tip-item { display: flex; align-items: flex-start; gap: 10px; padding: 13px 14px; border-radius: 10px; }
.tip-item + .tip-item { margin-top: 10px; }
.tip-item-icon { flex: 0 0 auto; margin-top: 1px; font-size: 20px; }
.tip-item strong { display: block; margin-bottom: 3px; color: #334155; font-size: 13px; line-height: 1.5; }
.tip-item p { margin: 0; }
.tip-neutral { background: #f8fafc; }
.tip-neutral .tip-item-icon { color: #64748b; }
.tip-warning { background: #fff8eb; }
.tip-warning .tip-item-icon, .tip-warning strong { color: #d97706; }
.dialog-footer { display: flex; justify-content: flex-end; gap: 10px; }
.dialog-footer .el-button { min-width: 104px; margin: 0; border-radius: 8px; }

@media (max-width: 768px) {
  .tool-page { padding: 14px 14px 32px; }
  .tool-content { padding-bottom: 32px; }
  .tool-card { padding: 16px 16px 32px; }
  .pics-grid { grid-template-columns: repeat(2, 1fr); }
  .pic-image { height: 130px; }
}
</style>

<style>
.qsy2-dialog { overflow: hidden; border-radius: 16px; box-shadow: 0 20px 60px rgba(15,23,42,.18); }
.qsy2-dialog .el-dialog__header { padding: 22px 24px 18px; border-bottom: 1px solid #eef2f7; }
.qsy2-dialog .el-dialog__headerbtn { top: 22px; right: 22px; }
.qsy2-dialog .el-dialog__headerbtn .el-dialog__close { color: #94a3b8; font-size: 19px; }
.qsy2-dialog .el-dialog__headerbtn:hover .el-dialog__close { color: #1a73e8; }
.qsy2-dialog .el-dialog__body { padding: 20px 24px; }
.qsy2-dialog .el-dialog__footer { padding: 0 24px 22px; }
.qsy2-dialog .dialog-footer .el-button--default { border-color: #dbe3ee; color: #64748b; }
.qsy2-dialog .dialog-footer .el-button--primary { border-color: #1a73e8; background: #1a73e8; box-shadow: 0 5px 14px rgba(26,115,232,.22); }
.qsy2-dialog .dialog-footer .el-button--primary:hover { border-color: #1765cc; background: #1765cc; }

@media (max-width: 700px) {
  .qsy2-dialog { width: 92% !important; max-width: 440px; }
  .qsy2-dialog .el-dialog__header { padding: 18px 18px 15px; }
  .qsy2-dialog .el-dialog__headerbtn { top: 18px; right: 18px; }
  .qsy2-dialog .el-dialog__body { padding: 16px 18px; }
  .qsy2-dialog .el-dialog__footer { padding: 0 18px 18px; }
}
</style>



// WEBPACK FOOTER //
// src/components/User2/Qsy.vue